import "datatables.net-bs5";
import "datatables.net-bs5/css/dataTables.bootstrap5.css";

import "datatables.net-responsive-bs5";
import "datatables.net-responsive-bs5/css/responsive.bootstrap5.css";

$(function () {
    const $table = $("table.table-searchable");

    if (!$table.length) {
        return;
    }

    $table.DataTable({
        responsive: true,
        pageLength: 25,
        order: [[0, "asc"]],
        language: {
            search: "",
            searchPlaceholder: "Search..."
        }
    });
});